import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import HorizontalCard from "../components/card/HorizontalCard";
import VerticleCard from "../components/card/VerticleCard";
import NewsService from "../services/news";
import ActivitiesService from "../services/activities";
import ArticleService from "../services/article";
import VideoService from "../services/video";
import ImageCard from "../components/card/ImageCard";
import GalleriesService from "../services/gallery";

export default function ContentDetail(props) {
  let { tag, lang } = useParams();
  let [newsData, setNewsData] = useState([]);
  let [activitiesData, setActivitiesData] = useState([]);
  let [articleData, setArticleData] = useState([]);

  let [videoData, setVideoData] = useState([]);
  let [galleryData, setGalleryData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getNewsData();
    getActivitiesData();
    getArticleData();
    getVideoData();
    getGalleryData();
    // eslint-disable-next-line
  }, []);

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`${process.env.REACT_APP_WEB_URL}/th`, "_self");
    }
  });

  const getNewsData = async () => {
    try {
      let [res] = await NewsService.getNewsByTag({
        tag: tag,
      });
      setNewsData(res);
    } catch {
      console.error();
    }
  };

  const getActivitiesData = async () => {
    try {
      let [res] = await ActivitiesService.getActivitiesByTag({
        tag: tag,
      });
      setActivitiesData(res);
    } catch {
      console.error();
    }
  };

  const getArticleData = async () => {
    try {
      let [res] = await ArticleService.getArticleByTag({
        tag: tag,
      });
      setArticleData(res);
    } catch {
      console.error();
    }
  };

  const getVideoData = async () => {
    try {
      let [res] = await VideoService.getVideoByTag({
        tag: tag,
      });
      setVideoData(res);
    } catch {
      console.error();
    }
  };

  const getGalleryData = async () => {
    try {
      let [res] = await GalleriesService.getGalleryByTag({
        tag: tag,
      });
      setGalleryData(res);
    } catch {
      console.error();
    }
  };

  return (
    <div className="content-detail pt-[135px] lg:pt-[0px]">
      <div className="section">
        <div className="page-container">
          <div className="mt-[92px] mb-[46px]">
            <h1 className="text-[28px] xl:text-[32px] text-left capitalize mt-[25px]">
              #{tag}
            </h1>

            <div className="w-[120px] border-[1px] border-black my-[22px]" />

            <p className="text-[18px] xl:text-[20px] text-left capitalize mt-[25px]">
              {lang === "th"
                ? `แสดงผลข้อมูลจาก #${tag}`
                : `Show result from #${tag}`}
            </p>

            {newsData?.length === 0 &&
              activitiesData?.length === 0 &&
              articleData?.length === 0 &&
              videoData?.length === 0 &&
              galleryData?.length === 0 && (
                <h1 className="text-[28px] xl:text-[32px] text-left capitalize mt-[25px]">
                  {lang === "th" ? "ไม่พบข้อมูล" : "Not found"}
                </h1>
              )}

            {newsData && newsData.length > 0 && (
              <div>
                <h1 className="text-[24px] xl:text-[28px] text-left capitalize mt-[25px]">
                  {lang === "th" ? "ข่าวสาร" : "News"}
                </h1>
                <div className="flex flex-col gap-[27px] mt-[38px]">
                  {newsData.map((item, i) => (
                    <HorizontalCard
                      data={item}
                      key={i}
                      page="newsAndActivity/news"
                      lang={lang}
                    />
                  ))}
                </div>
              </div>
            )}

            {activitiesData && activitiesData.length > 0 && (
              <div>
                <h1 className="text-[24px] xl:text-[28px] text-left capitalize mt-[25px]">
                  {lang === "th" ? "กิจกรรม" : "Activities"}
                </h1>
                <div id="news-activity" className="flex gap-[27px] mt-[38px]">
                  {activitiesData &&
                    activitiesData.map((item, i) => (
                      <VerticleCard
                        data={item}
                        key={i}
                        page="newsAndActivity/activity"
                        lang={lang}
                      />
                    ))}
                </div>
              </div>
            )}

            {articleData && articleData.length > 0 && (
              <div>
                <h1 className="text-[24px] xl:text-[28px] text-left capitalize mt-[25px]">
                  {lang === "th" ? "บทความ" : "Articles"}
                </h1>
                <div className="flex flex-col gap-[20px] mt-[38px]">
                  {articleData &&
                    articleData.map((item, i) => (
                      <HorizontalCard
                        data={item}
                        key={i}
                        lang={lang}
                        page={"article"}
                      />
                    ))}
                </div>
              </div>
            )}

            {videoData && videoData.length > 0 && (
              <div>
                <h1 className="text-[24px] xl:text-[28px] text-left capitalize mt-[25px]">
                  {lang === "th" ? "วิดีโอ" : "Videos"}
                </h1>
                <div
                  id="image-activity"
                  className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 lg:flex-row gap-[50px] mt-[38px]"
                >
                  {videoData &&
                    videoData.map((item, i) => (
                      <ImageCard
                        data={item}
                        isVideo={true}
                        key={i}
                        lang={lang}
                      />
                    ))}
                </div>
              </div>
            )}

            {galleryData && galleryData.length > 0 && (
              <div>
                <h1 className="text-[24px] xl:text-[28px] text-left capitalize mt-[25px]">
                  {lang === "th" ? "ประมวลภาพกิจกรรม" : "Galleries"}
                </h1>
                <div
                  id="image-activity"
                  className="grid grid-cols-3 lg:flex-row gap-[30px] mt-[68px]"
                >
                  {galleryData &&
                    galleryData?.map((item, i) => (
                      <ImageCard data={item} key={i} lang={lang} />
                    ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
